import { TrackJS } from 'trackjs';

export default () => {
    const showcasePath = window.appConfig?.showcasePath;

    if (!showcasePath) {
        TrackJS.track('showcasePath is not defined');

        return '';
    }

    return showcasePath.replace(/\/+$/, '');
};
